  <div class="ModalProps">
    <div class="head">
      <h1>Start New Chat</h1>
      <i class="fa fa-times" aria-hidden="true" (click)="closeDialog()"></i>
    </div>
    <div class="iq-card">
      <div class="iq-card-header">
        <div class="row py-3">
          <div class="col-sm-8">
            <div class="input-group">
              <input type="text" #ngSearch id="search" class="form-control" placeholder="Search By Name" (keyup.enter)="getSearchData()">
              <div class="input-group-append cp" *ngIf="search" (click)="clearSearch()"> <span class="input-group-text" style="padding: 0.685rem 0.75rem;cursor:pointer">
                  <i class="fa fa-times"></i>
                </span> </div>
              <div class="input-group-append cp" (click)="getSearchData()"> <span class="input-group-text" style="padding: 0.685rem 0.75rem;cursor:pointer">
                  <i class="fa fa-search"></i>
                </span> </div>
            </div>
          </div>
          <div class="col-sm-4">
            <button type="button" class="btn btn-theme w-150" (click)="getSearchData()"><i class="fa fa-search"></i> Search</button>
          </div>
        </div>
      </div>
    </div>
    <div class="gridDv" [ngClass]="{'cspinner load1': this.showLoader}">
      <div>
      <div class="item" *ngFor="let item of infoData">
        <div class="firstDv">
          <img *ngIf="item.photoUrl" [src]="item.photoUrl">
          <img *ngIf="!item.photoUrl" src="../../../assets/images_v2/dummyProfile.png">
          <div class="textDv">
            <h1>{{ item.firstName }} {{ item.lastName }}</h1>
            <p *ngIf="item.email">{{ item.email }}</p>
            <!-- <span>{{ item.phoneNumber }}</span> -->
          </div>
        </div>
        <a (click)="goToDetailChatManagement(item._id)">Chat</a>
      </div>
      <div class="not-found" *ngIf="infoData?.length === 0">
        <span>No Record(s) found</span>
      </div>
      </div>
    </div>
  </div>
